export default __webpack_public_path__ + "static/media/main.8eb54ba8.jpg";